import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { authActions } from 'features/auth'
import PageHeader from './PageHeader'

class PageHeaderContainer extends PureComponent {
	render() {
		return <PageHeader {...this.props} />
	}
}

const mapStateToProps = state => ({
	userProfile: state.auth,
	// saving: state.articles.saving,
	// savingSuccess: state.articles.savingSuccess,
})

const mapDispatchToProps = {
	signOut: authActions.logoutRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageHeaderContainer)
